export default {
	getBreadcrumb(state) {
		return state.breadcrumb;
	},
	getLoginMes(state) {
		return state.loginMes;
	},
	getLoginName(state) {
		return state.loginName;
	},
}
